// extracted by mini-css-extract-plugin
export var divider = "_ne-0";
export var systemMessage = "_ne-1";
export var systemMessageWrapper = "_ne-2";